import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectUI from '../../../widgets/form/InputSelectUI'
import InputDateUI from '../../../widgets/form/InputDateUI'

const OrderItemCreateModalUI = ({ context, messageList, successMsg, errorList, setErrorList,
  // modes
  createMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // product item id
  productItemId, productItemIdList, onProductItemIdChange, productItemIdError,
  // quantity
  quantity, onQuantityChange, quantityError, setQuantityError,
  // price
  price, onPriceChange, priceError, setPriceError,
  // due date
  dueDate, onDueDateChange, dueDateError, setDueDateError
}) =>
  <ModalFormUI
    context={context}
    messageList={messageList}
    titleMessageKey='c_create_order_item'
    buttonMessageKey='c_add'
    cancelMessageKey='c_cancel'
    isOpen={createMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectUI name='productItemId' value={productItemId} required={true}
      messageList={messageList} labelKey='c_product'
      optionList={productItemIdList}
      onChange={onProductItemIdChange} error={productItemIdError}
    />
    <InputTextSF type='positive_integer' name='quantity' required={true} maxLength={5}
      messageList={messageList} labelKey='c_quantity'
      value={quantity} onChange={onQuantityChange}
      error={quantityError} setError={setQuantityError}
      autoFocus={true}
    />
    <InputTextSF type='price' name='price' required={true} maxLength={13}
      messageList={messageList} labelKey='c_price'
      value={price} onChange={onPriceChange}
      error={priceError} setError={setPriceError}
      autoFocus={true}
    />
    <InputDateUI context={context} name='dueDate'
      messageList={messageList} labelKey='c_due_date'
      selectedDateISO={dueDate} onChange={onDueDateChange}
      error={dueDateError} setError={setDueDateError}
    />
  </ModalFormUI>

export default OrderItemCreateModalUI
